import * as types from './mutation_types';
import {API_ENTRYPOINT} from "../../../config/entrypoint";
import fetch from "../../../utils/fetch";
import {markPvpSelfAction} from "../../../utils/pvpSelfActionTracker";

export const reset = ({ commit }) => {
  commit(types.TRAINER_RESET);
};

export const resetError = ({ commit }) => {
  commit(types.TRAINER_RESET_ERROR);
};

export const loadItems = ({commit, dispatch}) => {
  const url = new URL("api/trainers", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_ITEMS, data['member']);
    })
    .catch((e) => {
      commit(types.TRAINER_SET_ERROR, e.message);
    });
};

export const loadItem = ({commit, dispatch}, id) => {
  commit(types.TRAINER_SET_LOADING, true);
  const url = new URL("api/trainers/"+id, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch}, id)
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ITEM, data);
      return data;
    })
    .catch((e) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ERROR, e.message);
    });
};

export const fetchObject = ({commit, dispatch},obj) => {
  commit(types.TRAINER_SET_LOADING, true);

  if (obj.method === 'GET'){
    return fetch(obj.url, {dispatch: dispatch})
      .then((response) => response.json())
      .then((data) => {
        commit(types.TRAINER_SET_LOADING, false);
        return data;
      })
      .catch((e) => {
        commit(types.TRAINER_SET_LOADING, false);
        commit(types.TRAINER_SET_ERROR, e.message);
      });
  }
  // OTHER
  return fetch(obj.url, {method: obj.method, body: JSON.stringify(obj.obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_LOADING, false);
      return data;
    })
    .catch((e) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ERROR, e.message);
    });
};

// Spousta míst v appce si po přechodu na novou obrazovku/po tahu v souboji
// samo volá loadInfoMessages (viz created() ve *Next.vue, BattleScreen.vue
// po pokemonFight) - při výherním tahu se tak snadno sejdou dva souběžné
// požadavky. Endpoint (GetInfoMessagesWithNewAction) přečte zprávy a AŽ
// PAK je označí new=false - když doběhnou souběžně, ten pozdější je může
// vidět už jako new=false (podle druhého už odflushnutého), a plný přepis
// TRAINER_SET_INFO_MESSAGES pak smaže new:true, co nastavil ten první -
// toast v App.vue tak nikdy neuvidí message['new']. Sdílení jednoho
// in-flight requestu napříč voláními to řeší u kořene (žádný souběh na BE).
let infoMessagesRequest = null;

export const loadInfoMessages = ({commit, dispatch}, id) => {
  if (infoMessagesRequest) {
    return infoMessagesRequest;
  }
  const url = new URL("api/get-info-messages-with-new/"+id, API_ENTRYPOINT);

  infoMessagesRequest = fetch(url, {dispatch: dispatch}, id)
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_INFO_MESSAGES, data);
    })
    .catch((e) => {
      commit(types.TRAINER_SET_ERROR, e.message);
    })
    .then(() => {
      infoMessagesRequest = null;
    });

  return infoMessagesRequest;
};


export const loadPokemons = ({dispatch}, pokemons) => {
  let pokemonsIds = '';
  for (let i = 0; i < pokemons.length; i++) {
    pokemonsIds += "&id[]=" + pokemons[i];
  }

  const url = new URL('api/pokemon?page=1'+pokemonsIds, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      return data['member'];
    })
    .catch(() => {
    });
};

export const useStoneToPokemon = ({commit,dispatch}, obj) => {
  const url = new URL("api/use-stone-to-pokemon", API_ENTRYPOINT);
  commit(types.TRAINER_SET_LOADING, true);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ITEM, data);
    })
    .catch((e) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ERROR, e.message);
    });
};

// Na rozdil od useStoneToPokemon vyse promita chybu dal (rethrow) - volajici
// (Items.vue) potrebuje rozlisit uspech/neuspech (napr. Vselek na endangered
// pokemona backend odmitne), ne se tvarit ze use vzdy projde.
export const useItem = ({commit, dispatch}, obj) => {
  const url = new URL("api/use-item", API_ENTRYPOINT);
  commit(types.TRAINER_SET_LOADING, true);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ITEM, data);
      return data;
    })
    .catch((e) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ERROR, e.message);
      throw e;
    });
};

// Volá journey/actions.js (trySyncOwnTrainerBalls) po kazde positionPost
// odpovedi, ktera obsahuje position.trainer.pokeballs/masterballs (dungeon,
// boje...) - promita cerstve hodnoty do ownTrainer bez dalsiho HTTP requestu,
// stejny vzor jako pokemon/refreshActiveTeam patch vetev.
export const patchOwnTrainerBalls = ({commit, state}, trainer) => {
  if (!trainer || !state.ownTrainer || state.ownTrainer.id !== trainer.id) {
    return;
  }
  commit(types.TRAINER_PATCH_OWN_TRAINER_BALLS, trainer);
};

// ownTrainer je oddělený od trainer/item, které jsou přepisovány při pohledu na cizí trenéry.
export const loadOwnTrainer = ({commit, dispatch}, id) => {
  const url = new URL("api/trainers/" + id, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      if (data) {
        commit(types.TRAINER_SET_OWN_TRAINER, data);
      }
      return data;
    })
    .catch((e) => {
      commit(types.TRAINER_SET_ERROR, e.message);
    });
};

// API vrací jen {}, proto se musí refetch ownTrainer - nezmenšovat lokálně.
// TRAINER_SET_LOADING zůstává true až do konce refetche, aby tlačítko nešlo
// dvakrát rychle za sebou stisknout dřív, než se sníží freeSkillpoints.
export const buyTrainerSkill = ({commit, dispatch}, {trainerId, skillName}) => {
  const url = new URL("api/trainer-buy-skill", API_ENTRYPOINT);
  commit(types.TRAINER_SET_LOADING, true);

  return fetch(url, {method: 'POST', body: JSON.stringify({trainerId, skillName}), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      if (data === undefined) {
        commit(types.TRAINER_SET_LOADING, false);
        return false;
      }
      return dispatch('loadOwnTrainer', trainerId).then(() => {
        commit(types.TRAINER_SET_LOADING, false);
        return true;
      });
    })
    .catch((e) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ERROR, e.message);
      return false;
    });
};

export const evolveEevee = ({commit,dispatch}, obj) => {
  const url = new URL("api/evolve-eevee-pokemon", API_ENTRYPOINT);
  commit(types.TRAINER_SET_LOADING, true);
  commit(types.TRAINER_SET_LOADING, true);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ITEM, data['trainer']);
      return data;
    })
    .catch((e) => {
      commit(types.TRAINER_SET_LOADING, false);
      commit(types.TRAINER_SET_ERROR, e.message);
    });
};

// Zpravy mezi hraci - vsechny 4 akce jen vraceji data volajicimu (stejny
// vzor jako loadPokemons vyse), zadny novy Vuex state/mutace -
// PlayerChatPopup.vue/TeamBottomSheet.vue si vysledek drzi lokalne.
export const searchTrainerByName = ({dispatch}, name) => {
  const url = new URL("api/trainers?npc=false&name=" + encodeURIComponent(name), API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => data['member'])
    .catch(() => []);
};

export const loadPlayerConversations = ({dispatch}, trainerId) => {
  const url = new URL("api/get-player-conversations/" + trainerId, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .catch(() => []);
};

export const loadPlayerMessages = ({dispatch}, {trainerId, otherId}) => {
  const url = new URL("api/get-player-messages/" + trainerId + "/" + otherId, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .catch(() => []);
};

export const sendPlayerMessage = ({dispatch}, {receiverId, text}) => {
  const url = new URL("api/send-player-message", API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify({receiverId, text}), dispatch: dispatch})
    .then((response) => response.json());
};
// PvP souboje mezi hráči (viz docs/superpowers/specs/2026-08-17-pvp-fights-design.md)
// - commituje do `pvpMatches`, ostatni stejny vzor jako zpravy.
// Ctecí volání (list/detail) zahazují chybu a vrací bezpečný fallback -
// mutační volání (challenge/accept/decline/choose-*) chybu NEZAHAZUJÍ,
// volající si je musí odchytit sám (translateError() z fetch.js).
export const loadPvpMatches = ({commit, dispatch}) => {
  const url = new URL("api/pvp/list", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_PVP_MATCHES, data || []);
      return data;
    })
    .catch(() => []);
};

export const loadPvpMatch = ({dispatch}, matchId) => {
  const url = new URL("api/pvp/" + matchId, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .catch(() => null);
};

// Celozivotni PvP statistiky, pocitane z PvpMatchResult na BE (viz
// GetPvpStatsAction) - nezavisle na tom, kolik PvpMatch radku je prave otevrenych.
export const loadPvpStats = ({dispatch}) => {
  const url = new URL("api/pvp/stats", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .catch(() => ({wins: 0, totalMatches: 0, radar: null, radarMatchCount: 0}));
};

// Cachovany seznam vsech hracu pro PvP vyhledavani/napovidani - misto dotazu
// na kazde stisknuti klavesy (drivejsi searchTrainerByName pres debounce) se
// cely seznam natahne jednou za nacteni appky (modulovy cache promise,
// sdileny mezi TeamBottomSheet.vue a PvpHub.vue), filtrovani jmenem uz
// probiha na klientovi.
let cachedAllPlayersPromise = null;

export const loadAllPlayers = ({dispatch}, {forceRefresh = false} = {}) => {
  if (cachedAllPlayersPromise && !forceRefresh) {
    return cachedAllPlayersPromise;
  }
  const url = new URL("api/trainers?npc=false&itemsPerPage=200", API_ENTRYPOINT);
  cachedAllPlayersPromise = fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => data['member'] || [])
    .catch(() => {
      cachedAllPlayersPromise = null;
      return [];
    });
  return cachedAllPlayersPromise;
};

// markPvpSelfAction() volano tady, na jedinem miste, kudy VSECHNY PvP
// mutace prochazeji (viz komentar v pvpSelfActionTracker.js) - zadna
// volajici komponenta si to nemusi hlidat sama.
export const challengePvp = ({dispatch}, {receiverId, matchSize}) => {
  const url = new URL("api/pvp/challenge", API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify({receiverId, matchSize}), dispatch: dispatch})
    .then((response) => response.json())
    .then((match) => {
      markPvpSelfAction(match?.id);
      return match;
    });
};

export const acceptPvp = ({dispatch}, matchId) => {
  const url = new URL("api/pvp/" + matchId + "/accept", API_ENTRYPOINT);

  markPvpSelfAction(matchId);
  return fetch(url, {method: 'POST', dispatch: dispatch})
    .then((response) => response.json());
};

export const declinePvp = ({dispatch}, matchId) => {
  const url = new URL("api/pvp/" + matchId + "/decline", API_ENTRYPOINT);

  markPvpSelfAction(matchId);
  return fetch(url, {method: 'POST', dispatch: dispatch})
    .then((response) => response.json());
};

export const choosePvpPokemon = ({dispatch}, {matchId, pokemonId}) => {
  const url = new URL("api/pvp/" + matchId + "/choose-pokemon", API_ENTRYPOINT);

  markPvpSelfAction(matchId);
  return fetch(url, {method: 'POST', body: JSON.stringify({pokemonId}), dispatch: dispatch})
    .then((response) => response.json());
};

export const choosePvpSkill = ({dispatch}, {matchId, skillId}) => {
  const url = new URL("api/pvp/" + matchId + "/choose-skill", API_ENTRYPOINT);

  markPvpSelfAction(matchId);
  return fetch(url, {method: 'POST', body: JSON.stringify({skillId}), dispatch: dispatch})
    .then((response) => response.json());
};

// Vzdání se (viz docs/superpowers/specs/2026-08-20-pvp-surrender-recall-design.md)
// okamzite ukonci CELY zapas jako prohru, bez ohledu na matchSize/zbyle pokemony.
export const surrenderPvp = ({dispatch}, matchId) => {
  const url = new URL("api/pvp/" + matchId + "/surrender", API_ENTRYPOINT);

  markPvpSelfAction(matchId);
  return fetch(url, {method: 'POST', dispatch: dispatch})
    .then((response) => response.json());
};

// Stazeni pokemona vzda jen aktualni par, zapas pokracuje dalsim pokemonem
// (nebo skonci, pokud uz zadny dalsi neni).
export const recallPvpPokemon = ({dispatch}, matchId) => {
  const url = new URL("api/pvp/" + matchId + "/recall", API_ENTRYPOINT);

  markPvpSelfAction(matchId);
  return fetch(url, {method: 'POST', dispatch: dispatch})
    .then((response) => response.json());
};

// PvP Ranked liga (viz docs/superpowers/specs/2026-08-26-pvp-ranked-league-frontend-design.md)
// - commituje do `pvpRankedList`, vlastni sada endpointu vedle volneho PvP vyse.
// Ctecí volání zahazují chybu a vrací bezpečný fallback (stejná konvence
// jako loadPvpMatches/loadPvpStats vyse), mutační volání chybu propagují -
// volajici komponenta si ji odchyti sama.
export const loadPvpRankedList = ({commit, dispatch}) => {
  const url = new URL("api/pvp-ranked/list", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.TRAINER_SET_PVP_RANKED_LIST, data || []);
      return data;
    })
    .catch(() => []);
};

export const loadPvpRankedLeaderboard = ({dispatch}) => {
  const url = new URL("api/pvp-ranked/leaderboard", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .catch(() => []);
};

export const loadPvpRankedAvailableLevels = ({dispatch}, opponentId) => {
  const url = new URL("api/pvp-ranked/available-levels", API_ENTRYPOINT);
  if (opponentId) {
    url.searchParams.set("opponentId", opponentId);
  }

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => data.levels || [])
    .catch(() => []);
};

export const proposePvpRanked = ({dispatch}, {receiverId, level}) => {
  const url = new URL("api/pvp-ranked/propose", API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify({receiverId, level}), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      markPvpSelfAction('ranked:' + data?.id);
      return data;
    });
};

export const counterProposePvpRanked = ({dispatch}, {challengeId, level}) => {
  const url = new URL("api/pvp-ranked/" + challengeId + "/counter-propose", API_ENTRYPOINT);

  markPvpSelfAction('ranked:' + challengeId);
  return fetch(url, {method: 'POST', body: JSON.stringify({level}), dispatch: dispatch})
    .then((response) => response.json());
};

export const acceptPvpRanked = ({dispatch}, challengeId) => {
  const url = new URL("api/pvp-ranked/" + challengeId + "/accept", API_ENTRYPOINT);

  markPvpSelfAction('ranked:' + challengeId);
  return fetch(url, {method: 'POST', dispatch: dispatch})
    .then((response) => response.json());
};

export const declinePvpRanked = ({dispatch}, challengeId) => {
  const url = new URL("api/pvp-ranked/" + challengeId + "/decline", API_ENTRYPOINT);

  markPvpSelfAction('ranked:' + challengeId);
  return fetch(url, {method: 'POST', dispatch: dispatch})
    .then((response) => response.json());
};

// Trziste pro vymenu evolucnich kamenu (zadani uzivatele 2026-08-29, viz
// docs/superpowers/specs/2026-08-29-stone-trade-marketplace-design.md) -
// stejny vzor jako PvP akce vyse: zadny novy Vuex state/mutace, kazda akce
// jen vraci data volajicimu (TradeHub.vue si vysledek drzi lokalne).
export const loadTradeMarketplace = ({dispatch}) => {
  const url = new URL("api/trade-offers", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json());
};

export const loadStoneTypes = ({dispatch}) => {
  const url = new URL("api/trade-offer/stone-types", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json());
};

export const loadMyTradeOffers = ({dispatch}) => {
  const url = new URL("api/trade-offers/mine", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json());
};

export const createTradeOffer = ({dispatch}, {itemId, wantedTypeIds, acceptWeakerStone}) => {
  const url = new URL("api/trade-offer/create", API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify({itemId, wantedTypeIds, acceptWeakerStone}), dispatch: dispatch})
    .then((response) => response.json());
};

export const fulfillTradeOffer = ({dispatch}, {tradeOfferId, myItemId}) => {
  const url = new URL("api/trade-offer/" + tradeOfferId + "/fulfill", API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify({myItemId}), dispatch: dispatch})
    .then((response) => response.json());
};

export const cancelTradeOffer = ({dispatch}, tradeOfferId) => {
  const url = new URL("api/trade-offer/" + tradeOfferId + "/cancel", API_ENTRYPOINT);

  return fetch(url, {method: 'POST', dispatch: dispatch})
    .then((response) => response.json());
};
